import React from 'react';
import { Section } from './ui/Section';
import { Clock, Smartphone, Heart, AlertCircle } from 'lucide-react';
export function Problem() {
  return <Section className="bg-white" data-id="element-445">
      <div className="space-y-8" data-id="element-446">
        <div className="prose prose-lg mx-auto text-gray-600 text-center" data-id="element-447">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-448">
            Si has pensado "yo no nací para vender"...{' '}
            <br className="hidden md:block" data-id="element-449" />
            <span className="text-brand-pink" data-id="element-450">
              no es verdad. Solo te falta el mapa.
            </span>
          </h2>
          <p className="text-lg leading-relaxed mb-6" data-id="element-451">
            Hay mamás que quieren ayudar en la casa, pagar pañales, ahorrar,
            salir de deudas… Pero se sienten atrapadas.
          </p>
        </div>

        <div className="mt-8 bg-gray-50 rounded-2xl p-8 md:p-10 border border-gray-100 max-w-4xl mx-auto" data-id="element-452">
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-453">
            <div data-id="element-454">
              <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-455">
                Te sientes atrapada entre:
              </h3>
              <ul className="space-y-4" data-id="element-456">
                {['“No tengo tiempo.”', '“No soy experta en nada.”', '“No sé qué PDF crear.”', '“Me da pena ofrecer algo.”', '“No sé diseñar.”'].map((item, i) => <li key={i} className="flex items-center text-gray-700 font-medium" data-id="element-457">
                    <AlertCircle className="w-5 h-5 text-rose-400 mr-3 flex-shrink-0" data-id="element-458" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-459">
              <p className="text-lg font-medium text-gray-800 mb-4" data-id="element-460">
                Y mientras tanto… el mes vuelve a empezar con las mismas
                preocupaciones.
              </p>
              <div className="h-px w-full bg-gray-100 my-4" data-id="element-461"></div>
              <p className="text-xl font-bold text-brand-pink" data-id="element-462">
                La realidad: no necesitas más talento.
              </p>
              <p className="text-gray-600 mt-2" data-id="element-463">
                Necesitas un proceso simple + herramientas que hagan el trabajo
                pesado contigo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}